// Fallback locale usato solo se il server non riesce a leggere Instagram.
// Il sito prova ad aggiornarsi da solo e rinnova il feed ogni 30 giorni.
export const INSTAGRAM_POSTS = [
  {
    id: "DdB1yNjNdYY",
    image:
      "https://static.prod-images.emergentagent.com/jobs/3fe2f404-800d-42d4-b3a9-254e5e4481e7/images/0a130531ee72be16c0d8597ba15cf165683e3d27ae33e137723b3677baae9271.jpeg",
    caption:
      "Il primo appuntamento della rete DonnaImpresa: imprenditrici a confronto.",
    permalink: "https://www.instagram.com/p/DdB1yNjNdYY/",
    data: "",
  },
  {
    id: "profilo",
    image:
      "https://static.prod-images.emergentagent.com/jobs/3fe2f404-800d-42d4-b3a9-254e5e4481e7/images/1079b8e050c904b3933395d8ecd41e1405098afdd1b78a9a6bf0f8accb65c2e6.jpeg",
    caption:
      "Storie di impresa e obiettivi condivisi: tutti gli aggiornamenti sul profilo Instagram di DonnaImpresa.",
    permalink: "https://www.instagram.com/donnaimpresa",
    data: "",
  },
];
